import { Injectable } from '@angular/core';
import { CookieConsentService } from '@shared/services/cookies.service';


@Injectable({
  providedIn: 'root',
})

export class TrackingService {
  constructor(private cookieConsentService: CookieConsentService) {}

  private hasConsent(): boolean {
    // !! Sending analytics tracking without consent as requested by the marketing team
    // return this.cookieConsentService.has('analytics'); // Uncomment this line to enable analytics tracking based on user consent
    return true; 
  }

  // ** Google Tracking Manager (GTM) and Google Analytics (GA4) Initialization
  initializeTracking() {
    if (this.hasConsent()) {
      this.loadGTM('GTM-NDH9DXQ');
      this.loadGtag('G-E8JBXT22RD');
    }
  }

  logEvent(eventName: string, payload: Record<string, any>) {
    if (this.hasConsent()) {
      (window as any).gtag('event', eventName, payload);
    }
  }

  private loadGTM(id: string) {
    window['dataLayer'] = window['dataLayer'] || [];
    window['dataLayer'].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });
  
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${id}`;
    document.head.appendChild(script);
  }

  private loadGtag (id: string) {
    const gtagScript = document.createElement('script');
    gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    gtagScript.async = true;
    document.head.appendChild(gtagScript);

    gtagScript.onload = () => {
      (window as any).dataLayer = (window as any).dataLayer || [];
      function gtag(...args: any[]) {
        (window as any).dataLayer.push(args);
      }
      gtag('js', new Date());
      gtag('config', id);
    };
  }
}

// ** TikTok Tracking Service
declare const ttq: any;

@Injectable({ providedIn: 'root' })
export class TiktokTrackingService {
  constructor(private cookieConsentService: CookieConsentService) {}

  private hasConsent(): boolean {
    return this.cookieConsentService.has('analytics');
  }

  trackViewContent(contentData: any) {
    if (this.hasConsent() && typeof ttq !== 'undefined') {
      ttq.track('ViewContent', { contents: [contentData] });
    }
  }

  trackContact(contentData: any) {
    if (this.hasConsent() && typeof ttq !== 'undefined') {
      ttq.track('Contact', { contents: [contentData] });
    }
  }

  trackSubmitForm(contentData: any) {
    if (this.hasConsent() && typeof ttq !== 'undefined') {
      ttq.track('SubmitForm', { contents: [contentData] });
    }
  }
}

// ** SnapEngage Tracking Service
declare global {
  interface Window {
    snaptr: Function;
  }
}

@Injectable({ providedIn: 'root' })
export class SnapEngageService {
  constructor(private cookieConsentService: CookieConsentService) {}

  private hasConsent(): boolean {
    return this.cookieConsentService.has('analytics');
  }

  trackSignUp(
    signUpMethod: string,
    uuidC1: string,
    userEmail: string,
    userPhoneNumber: string,
    userHashedEmail: string,
    userHashedPhoneNumber: string
  ) {
    if (!this.hasConsent()) {
      console.warn('SnapEngage tracking skipped due to no consent.');
      return;
    }

    if (window.snaptr) {
      window.snaptr('track', 'SIGN_UP', {
        sign_up_method: signUpMethod,
        uuid_c1: uuidC1,
        user_email: userEmail,
        user_phone_number: userPhoneNumber,
        user_hashed_email: userHashedEmail,
        user_hashed_phone_number: userHashedPhoneNumber,
      });
    } else {
      console.error('SnapEngage tracking function not found.');
    }
  }
}